import React from "react";
import Lottie from "react-lottie";
import * as animationData from "../../../assets/lottie/error-lottie-2.json";

const Error = ({ message = "Unexpected Error!" }) => {
  const defaultOptions = {
    loop: true,
    autoplay: true,
    animationData: animationData,
  };
  return (
    <div className="mx-auto my-auto">
      <Lottie
        style={{
          cursor: "default",
          userSelect: "none",
        }}
        options={defaultOptions}
        height={350}
        width={350}
      />
      <h1 className="text-center text-3xl text-white">{message}</h1>
    </div>
  );
};

export default Error;
